import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import PhoneCallbackIcon from "@mui/icons-material/PhoneCallback";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import SchoolIcon from "@mui/icons-material/School";
import type {
  HelpCentreLink,
  HelpCentreSupportDetail,
} from "./help-center-types";

export const ECARE_UNIVERSITY_URL =
  "https://ecarehealthsolution.zendesk.com/hc/en-us";

export const EXTERNAL_LINK_TARGET = "_blank";
export const EXTERNAL_LINK_FEATURES = "noopener,noreferrer";
export const MAILTO_PREFIX = "mailto:";
/** only http(s) destinations open in a new tab; mailto:/tel: hand off to the OS */
export const NEW_TAB_HREF_PREFIX = "http";

export const HELP_CENTRE_SECTION = {
  RAISE_TICKET: "raise_ticket",
  MAIL_US: "mail_us._support",
  CALL_BACK: "call_back._support",
} as const;

/** Floating panel anchor: just above the Help Centre item in the sidebar footer */
export const HELP_CENTRE_DIALOG_POSITION = { bottom: 76, left: 16 };

/** Where the Help Centre success toast appears (independent of the global notifications position) */
export const HELP_CENTRE_TOAST_POSITION = { bottom: 16, left: 16 };
export const HELP_CENTRE_TOAST_WIDTH = 350;

export const HELP_CENTRE_PANEL_WIDTH = 360;
export const HELP_CENTRE_PANEL_PADDING = 2;

export const HELP_CENTRE_HEADING_ICON_SIZE = 44;
export const HELP_CENTRE_HEADING_ICON_FONT_SIZE = 26;
export const HELP_CENTRE_BORDER_RADIUS = 1;
export const HELP_CENTRE_CARD_BORDER_OPACITY = 0.5;
export const HELP_CENTRE_CARD_BACKGROUND_OPACITY = 0.05;
export const HELP_CENTRE_CARD_TRANSITION = "box-shadow 150ms ease";
export const HELP_CENTRE_DISABLED_OPACITY = 0.5;

export const HELP_CENTRE_FONT_SIZE = {
  TITLE: 14,
  BODY: 14,
  CAPTION: 12,
} as const;

export const HELP_CENTRE_FONT_WEIGHT = {
  BOLD: 700,
  SEMI_BOLD: 600,
  MEDIUM: 500,
} as const;

export const HELP_CENTRE_TITLE = "Help Centre";
export const HELP_CENTRE_SUBTITLE = "All product help at one place.";
export const HELP_CENTRE_SUPPORT_TITLE = "Support Details";
export const HELP_CENTRE_RAISE_TICKET_TITLE = "Raise Ticket";
export const HELP_CENTRE_RAISE_TICKET_WIDTH = "600px";
export const HELP_CENTRE_MAIL_US_TITLE = "Mail Us";

export const SUPPORT_PHONE_DISPLAY = "+1 (251) 220-8987";
export const SUPPORT_PHONE_TEL = "+12512208987";
export const SUPPORT_EMAIL = "support+ech@medarch.com";

export const HELP_CENTRE_HEADING_ICON = MenuBookIcon;
export const HELP_CENTRE_LINK_ARROW_ICON = ArrowForwardIcon;

export const HELP_CENTRE_LINKS: HelpCentreLink[] = [
  {
    key: "ecareUniversity",
    label: "eCareUniversity",
    description: "Guides, training and product walkthroughs",
    icon: SchoolIcon,
    externalUrl: ECARE_UNIVERSITY_URL,
  },
  {
    key: "submitRequest",
    label: "Submit Request",
    description: "Support or feature request",
    icon: NoteAddIcon,
    section: HELP_CENTRE_SECTION.RAISE_TICKET,
  },
];

export const HELP_CENTRE_SUPPORT_DETAILS: HelpCentreSupportDetail[] = [
  {
    key: "callUs",
    label: `Call Us ${SUPPORT_PHONE_DISPLAY}`,
    icon: PhoneInTalkIcon,
  },
  {
    key: "emailUs",
    label: `Email us at ${SUPPORT_EMAIL}`,
    icon: MailOutlineIcon,
    href: `${MAILTO_PREFIX}${SUPPORT_EMAIL}`,
    action: "modal",
    section: HELP_CENTRE_SECTION.MAIL_US,
  },
  {
    key: "requestCallBack",
    label: "Request For Call Back",
    icon: PhoneCallbackIcon,
    section: HELP_CENTRE_SECTION.CALL_BACK,
    disabled: true,
  },
];
